import type { Option } from '@allesauto/core/searchDropdown';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CheckoutDeliveryState {
  selectedDealerSearchOption: Option | null;
}

export const initialState: CheckoutDeliveryState = {
  selectedDealerSearchOption: null,
};

const SLICE_NAME = 'checkout/delivery';

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    saveDealerSearchOption(
      state,
      action: PayloadAction<{
        option: CheckoutDeliveryState['selectedDealerSearchOption'];
      }>
    ) {
      state.selectedDealerSearchOption = action.payload.option;
    },
    updateCheckoutDeliveryState(
      state,
      action: PayloadAction<CheckoutDeliveryState>
    ) {
      return action.payload;
    },

    reset() {
      return initialState;
    },
  },
});

export const { saveDealerSearchOption, updateCheckoutDeliveryState, reset } =
  slice.actions;

export default slice.reducer;
